import * as tslib_1 from "tslib";
import { HttpClient, HttpParams } from '@angular/common/http';
import { InterfaceService } from '@app/interfaces';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var AdminService = /** @class */ (function (_super) {
    tslib_1.__extends(AdminService, _super);
    function AdminService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        return _this;
    }
    AdminService.prototype.getAllVehicleTrackerDevices = function () {
        var url = 'vehicletrackers';
        return this.http.get(this.getApiUrl(url));
    };
    AdminService.prototype.getClientsBasicDetails = function (clientId) {
        var url = 'clients/' + clientId + '/basicdetails';
        return this.http.get(this.getApiUrl(url));
    };
    AdminService.prototype.getLineItemPriceAccordingToQuantityRange = function (id, quantity) {
        var url = 'vehicletrackers/' + id + '/quantity/' + quantity + '/cost';
        return this.http.get(this.getApiUrl(url));
    };
    AdminService.prototype.getVehicleTrackerPrice = function (id, quantity) {
        var url = "vehicle_tracker/" + id + "/price?quantity=" + quantity;
        return this.http.get(this.getApiUrl(url));
    };
    AdminService.prototype.purchaseTrackerCheckoutSession = function (requestPayload) {
        var formData = new FormData();
        var url = 'vehicle_tracker/checkout_session';
        requestPayload.trackers.forEach(function (tracker, index) {
            Object.keys(tracker).forEach(function (key) {
                formData.append("trackers[" + index + "][" + key + "]", String(tracker[key]));
            });
        });
        // Append shippingAddress if present
        if (requestPayload.shippingAddress) {
            Object.keys(requestPayload.shippingAddress).forEach(function (key) {
                if (requestPayload.shippingAddress[key] !== undefined && requestPayload.shippingAddress[key] !== null) {
                    formData.append("shippingAddress[" + key + "]", String(requestPayload.shippingAddress[key]));
                }
            });
        }
        return this.http.post(this.getApiUrl(url), formData);
    };
    AdminService.prototype.getSuccessPayment = function (reference) {
        var url = "checkout_session/success?reference=" + reference;
        return this.http.get(this.getApiUrl(url));
    };
    AdminService.prototype.getCanceledPayment = function (reference) {
        var url = "checkout_session/cancel?reference=" + reference;
        return this.http.put(this.getApiUrl(url), {});
    };
    AdminService.prototype.getCheckoutSessionPayment = function () {
        var url = 'checkout_session_for_subscription';
        return this.http.get(this.getApiUrl(url));
    };
    AdminService.prototype.getCheckoutSessionPaymentInvoice = function () {
        var url = 'checkout_session_for_payment_required';
        return this.http.get(this.getApiUrl(url));
    };
    AdminService.prototype.getSummaryDetails = function () {
        var url = 'view_clients_license_summary';
        return this.http.get(this.getApiUrl(url));
    };
    AdminService.prototype.getClientInvoices = function (clientId, searchInvoiceId, page, pageSize, isNewAdmin, filters) {
        var url = "clients/" + clientId + "/invoices";
        // Build query params
        var httpParams = new HttpParams();
        if (searchInvoiceId)
            httpParams = httpParams.set('invoiceid', searchInvoiceId);
        if (page !== undefined)
            httpParams = httpParams.set('page', page.toString());
        if (pageSize !== undefined)
            httpParams = httpParams.set('limit', pageSize.toString());
        if (isNewAdmin) {
            // Use POST with filters in body
            var body = {};
            if (filters && filters.length > 0) {
                body.filters = filters;
            }
            return this.http.post(this.getApiUrl(url), body, { params: httpParams });
        }
        else {
            // Use GET for old admin
            return this.http.get(this.getApiUrl(url), { params: httpParams });
        }
    };
    AdminService.prototype.downloadInvoice = function (invoiceId) {
        var url = "download_invoice/" + invoiceId;
        return this.http.get(this.getApiUrl(url), { responseType: 'blob' });
    };
    AdminService.prototype.getClientsPaymentdetail = function (type) {
        var url = "clients_payment_details/" + type;
        return this.http.get(this.getApiUrl(url));
    };
    AdminService.prototype.getFilterInvoice = function () {
        var url = 'clients_invoice_filters';
        return this.http.get(this.getApiUrl(url));
    };
    AdminService.prototype.getdownloadContract = function () {
        var url = 'getContractPdfDownloadLink';
        return this.http.get(this.getApiUrl(url));
    };
    AdminService.prototype.getStripePublicKey = function () {
        var url = 'getStripePublicKey';
        return this.http.get(this.getApiUrl(url));
    };
    AdminService.prototype.cancelPurchaseTrackerOrder = function (transactionUUID) {
        var url = 'cancelPurchaseTrackerOrder?transactionUUID=' + transactionUUID;
        return this.http.delete(this.getApiUrl(url));
    };
    AdminService.prototype.getDeleteCard = function () {
        var url = 'get_deleted_stripe_account';
        return this.http.get(this.getApiUrl(url));
    };
    AdminService.prototype.getInvoiceDetail = function () {
        var url = 'payment_required_invoices';
        return this.http.get(this.getApiUrl(url));
    };
    AdminService.prototype.getVehicleTrackerHistory = function (params) {
        var url = 'vehicle_tracker/order/history';
        return this.http.get(this.getApiUrl(url), {
            params: {
                page: params.page.toString(),
                limit: params.limit.toString()
            }
        });
    };
    AdminService.prototype.getVehicleTrackerList = function () {
        var url = 'vehicle_tracker';
        return this.http.get(this.getApiUrl(url));
    };
    AdminService.prototype.addSmartDebit = function (payload) {
        var url = 'add_smart_debit';
        var body = payload;
        return this.http.put(this.getApiUrl(url), body);
    };
    AdminService.prototype.directDebitDetail = function () {
        var url = 'direct_debit_details';
        return this.http.get(this.getApiUrl(url));
    };
    AdminService.prototype.clientsPaymentMethod = function () {
        var url = 'clients_payment_method_settings';
        return this.http.get(this.getApiUrl(url));
    };
    AdminService.prototype.contractViewStatus = function () {
        var url = 'update_contract_view';
        return this.http.put(this.getApiUrl(url), {});
    };
    // Inside your component or service
    AdminService.prototype.transformSummaryDetails = function (originalSummaryDetails) {
        var originalLicenceDetails = originalSummaryDetails.licenceDetails, monthly = originalSummaryDetails.monthly, yearly = originalSummaryDetails.yearly, currency = originalSummaryDetails.currency, billingFrequency = originalSummaryDetails.billingFrequency, extraFields = tslib_1.__rest(originalSummaryDetails, ["licenceDetails", "monthly", "yearly", "currency", "billingFrequency"]);
        var transformedSummaryDetails = tslib_1.__assign({ licenceDetails: [], monthly: monthly,
            yearly: yearly,
            currency: currency,
            billingFrequency: billingFrequency }, extraFields);
        if (Array.isArray(originalLicenceDetails)) {
            originalLicenceDetails.forEach(function (licence) {
                var discountDetails = licence.discountDetails;
                if (Array.isArray(discountDetails) && discountDetails.length > 0) {
                    discountDetails.forEach(function (discount) {
                        transformedSummaryDetails.licenceDetails.push({
                            productLicenceName: licence.productLicenceName,
                            pricingPlansName: licence.pricingPlansName,
                            licenceTypesName: licence.licenceTypesName,
                            numberOfCl: discount.numberOfCl ? discount.numberOfCl : licence.numberOfCl,
                            licencePrice: licence.licencePrice,
                            discountPrice: discount.discountPrice ? discount.discountPrice : null,
                            total: discount.total ? discount.total : licence.total,
                            discountDetails: {
                                numberOfCl: discount.numberOfCl ? discount.numberOfCl : licence.numberOfCl,
                                basePrice: discount.basePrice ? discount.basePrice : licence.licencePrice,
                                discountPrice: discount.discountPrice ? discount.discountPrice : null,
                                total: discount.total ? discount.total : licence.total,
                                monthlyDiscount: discount.monthlyDiscount || [],
                                userRange: discount.userRange || []
                            },
                            basePrice: discount.basePrice ? discount.basePrice : licence.licencePrice
                        });
                    });
                }
                else {
                    // Single or no discount
                    transformedSummaryDetails.licenceDetails.push({
                        productLicenceName: licence.productLicenceName,
                        pricingPlansName: licence.pricingPlansName,
                        licenceTypesName: licence.licenceTypesName,
                        numberOfCl: licence.numberOfCl,
                        licencePrice: licence.licencePrice,
                        discountPrice: licence.discountPrice ? licence.discountPrice : null,
                        total: licence.total,
                        discountDetails: {
                            numberOfCl: licence.numberOfCl,
                            basePrice: licence.licencePrice,
                            discountPrice: licence.discountPrice ? licence.discountPrice : null,
                            total: licence.total,
                            monthlyDiscount: [],
                            userRange: []
                        },
                        basePrice: licence.licencePrice
                    });
                }
            });
        }
        return transformedSummaryDetails;
    };
    AdminService.prototype.hideTopBar = function () {
        var topBar = document.querySelector('.top_bar_wrapper');
        var container = document.querySelector('.app-container');
        if (topBar) {
            topBar.style.display = 'none';
            container.style.overflowY = 'hidden';
        }
    };
    AdminService.prototype.downloadContract = function (contractId) {
        var url = "download_contract/" + contractId;
        return this.http.get(this.getApiUrl(url), { responseType: 'blob' });
    };
    AdminService.ngInjectableDef = i0.defineInjectable({ factory: function AdminService_Factory() { return new AdminService(i0.inject(i1.HttpClient)); }, token: AdminService, providedIn: "root" });
    return AdminService;
}(InterfaceService));
export { AdminService };
